import { rolesManipulator, useGetUserRoleBusinessesIDs } from 'auth';
import { BUSINESS_QUERY_PARAM } from '@/modules/common/constants/search-params.ts';
import { useSyncQueryParamInLocalStorage } from 'ui/hooks';

export const useGetDefaultBusinessId = () => {
  const availableBusinessesIds = useGetUserRoleBusinessesIDs(rolesManipulator.current_user_role);
  const { getLocalStorageValue: getPreferenceBusinessId } =
    useSyncQueryParamInLocalStorage(BUSINESS_QUERY_PARAM);
  const preferenceBusinessId = getPreferenceBusinessId();

  if (preferenceBusinessId && availableBusinessesIds.includes(+preferenceBusinessId)) {
    return preferenceBusinessId;
  }

  return availableBusinessesIds[0] ? availableBusinessesIds[0].toString() : null;
};
